// extracted by mini-css-extract-plugin
export default {"header":"DeleteClientName_header__cIoAJ","icon":"DeleteClientName_icon__Qqjij"};